import React, { useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import { segmentIcon } from '../constants/segmentIcons';
import StepFooter from '../components/StepFooter';
import shell from '../SetupWizard.module.css';
import styles from './steps.module.css';

const TEAM_OPTIONS = [
  { key: 'solo', label: 'Atendo sozinho(a)', hint: 'A agenda é só sua', Icon: PersonIcon },
  { key: 'team', label: 'Tenho equipe', hint: 'Outros profissionais ou secretária', Icon: GroupsIcon },
];

/**
 * Passo 1: área de atuação (define ficha, especialidade, atendimentos sugeridos e os
 * horários padrão, save_area.php) e equipe. Depois que os exemplos da conta começam a
 * ser montados (passo 2 salvo), a área fica travada: só aparece a escolhida.
 */
function AreaStep({ data, wizard }) {
  const [segment, setSegment] = useState(data.area.segment || '');
  const [teamMode, setTeamMode] = useState(data.area.team_mode || '');
  const locked = wizard.areaLocked && !!data.area.segment;
  const segments = locked ? data.segments.filter((item) => item.key === data.area.segment) : data.segments;

  const submit = () => wizard.save('area', { segment, team_mode: teamMode });

  return (
    <>
      <h2 className={shell.stepTitle}>Qual é a sua área?</h2>
      <p className={shell.stepHint}>
        Com isso a Gabriela já monta a ficha de atendimento e sugere os seus procedimentos.
      </p>

      <div className={styles.segmentGrid} role="radiogroup" aria-label="Área de atuação">
        {segments.map((item) => {
          const Icon = segmentIcon(item.key);
          const selected = segment === item.key;
          return (
            <button
              key={item.key}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`${styles.segmentCard} ${selected ? styles.selected : ''}`}
              onClick={() => !locked && setSegment(item.key)}
            >
              <span className={styles.segmentIcon}><Icon /></span>
              <span className={styles.segmentLabel}>{item.label}</span>
            </button>
          );
        })}
      </div>
      {locked && (
        <p className={shell.fieldHint}>Os exemplos da sua conta já foram montados para esta área.</p>
      )}

      <span className={shell.sectionLabel}>Como você atende?</span>
      <div className={styles.optionRow} role="radiogroup" aria-label="Como você atende">
        {TEAM_OPTIONS.map(({ key, label, hint, Icon }) => (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={teamMode === key}
            className={`${styles.optionCard} ${teamMode === key ? styles.selected : ''}`}
            onClick={() => setTeamMode(key)}
          >
            <span className={styles.segmentIcon}><Icon /></span>
            <span>
              <span className={styles.optionLabel}>{label}</span>
              <span className={styles.optionHint}>{hint}</span>
            </span>
          </button>
        ))}
      </div>

      <StepFooter
        error={wizard.error?.message}
        onPrimary={submit}
        disabled={!segment || !teamMode}
        saving={wizard.saving}
      />
    </>
  );
}

export default AreaStep;
